import * as React from "react";
const SvgFiRrInvestment = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-investment_svg__a)">
      <path
        fill="#062147"
        d="M23.018 8.785a2.98 2.98 0 0 0-2.169-.782 2.98 2.98 0 0 0-2.085.981l-3.217 3.535A3.14 3.14 0 0 0 12.858 11H4c-2.206 0-4 1.794-4 4v5c0 2.206 1.794 4 4 4h4.965c2.849 0 5.57-1.22 7.467-3.348l6.804-7.637a3.02 3.02 0 0 0-.218-4.23m-1.275 2.899-6.804 7.638A8.02 8.02 0 0 1 8.965 22H4c-1.103 0-2-.897-2-2v-5c0-1.103.897-2 2-2h8.858c.629 0 1.142.513 1.142 1.143 0 .564-.421 1.051-.98 1.13l-5.161.737a1 1 0 0 0 .283 1.981l5.161-.737a3.16 3.16 0 0 0 2.514-2.058l4.427-4.865c.181-.2.43-.316.699-.329.272-.008.529.082.728.262.407.372.44 1.009.072 1.421zm-7.449-7.391a1 1 0 0 1 0-1.414L16.587.586A2.06 2.06 0 0 1 18.001 0c.5 0 1.041.212 1.414.586l2.293 2.293a.999.999 0 1 1-1.414 1.414L19.001 3v3a1 1 0 1 1-2 0V3l-1.293 1.293a1 1 0 0 1-1.414 0M6.751 9h3.5c1.517 0 2.75-1.31 2.75-2.919 0-1.665-1.581-3.473-3.138-4.223a5 5 0 0 0 .462-.531c.405-.55.032-1.326-.651-1.326H7.327c-.646 0-1.067.73-.695 1.259.151.214.327.415.51.598-1.558.75-3.14 2.559-3.14 4.224 0 1.61 1.233 2.919 2.75 2.919zm1.75-5.5c.745 0 2.5 1.527 2.5 2.581 0 .507-.336.919-.75.919h-3.5c-.414 0-.75-.413-.75-.919 0-1.054 1.755-2.581 2.5-2.581"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-investment_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrInvestment;
